export const fr = {
  common: {
    appName: 'MovMania',
    tagline: 'Bouge. Gagne. Recommence.',
    continue: 'Continuer',
    back: 'Retour',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    minutes: '{{count}} min',
    today: "Aujourd'hui",
    yesterday: 'Hier',
    daysAgo: 'Il y a {{count}} j',
  },

  onboarding: {
    welcomeTitle: 'Bouger, sans se forcer',
    welcomeBody:
      "MovMania ne cherche pas la performance. Il cherche à vous donner envie de revenir demain.",
    welcomeStart: 'Commencer',

    favoritesTitle: 'Qu’aimez-vous faire ?',
    favoritesBody: 'Choisissez-en autant que vous voulez. On adaptera les défis.',

    practiceTitle: 'Aujourd’hui, vous bougez combien ?',
    practiceBody: 'Soyez honnête : c’est un point de départ, pas un jugement.',
    practiceNone: 'Quasiment jamais',
    practiceNoneHint: 'Moins d’une fois par semaine',
    practiceOccasional: 'De temps en temps',
    practiceOccasionalHint: '1 à 2 fois par semaine',
    practiceRegular: 'Régulièrement',
    practiceRegularHint: '3 à 4 fois par semaine',
    practiceFrequent: 'Très souvent',
    practiceFrequentHint: '5 fois par semaine ou plus',

    bodyTitle: 'Quelques repères',
    bodyBody:
      'Uniquement pour estimer les calories de vos séances. Tout est facultatif et reste sur votre téléphone.',
    bodyAge: 'Âge',
    bodyHeight: 'Taille',
    bodyWeight: 'Poids',
    bodyYears: 'ans',

    goalTitle: 'Votre objectif principal',
    goalBody: 'Une seule intention, celle qui compte vraiment pour vous.',

    targetTitle: 'Votre objectif de la semaine',
    targetBody:
      'Un point de départ atteignable, calculé d’après ce que vous faites déjà. Modifiable à tout moment.',
    targetWho: 'Reco OMS : {{count}} min',
    targetBelowWho: 'En dessous de la reco OMS, volontairement. On s’en rapprochera.',
    targetAtWho: 'Pile sur la recommandation de l’OMS.',
    targetAboveWho: 'Au-dessus de la reco OMS. Beau programme.',

    nameTitle: 'Comment vous appelle-t-on ?',
    namePlaceholder: 'Votre prénom',
    finish: 'C’est parti',
  },

  week: {
    goalLabel: 'Votre objectif',
    whoLabel: 'Recommandation OMS',
    streak: 'semaine de suite',
    streak_plural: 'semaines de suite',
  },

  home: {
    greeting: 'Bonjour {{name}}',
    goalStart: 'Votre semaine commence ici',
    goalPercent: 'Vous êtes à {{percent}} % de votre objectif',
    goalReached: 'Objectif de la semaine atteint',
    thisWeek: 'Cette semaine',
    quickOther: 'Autre',
    quickLog: 'Enregistrer : {{activity}}',
    today: 'Aujourd’hui',
    todayMinutes: 'Minutes actives',
    todayKcal: 'Calories',
    quests: 'Défis',
    questsDaily: 'Du jour',
    questsWeekly: 'De la semaine',
    logActivity: 'Enregistrer une séance',
  },

  /**
   * Le "miroir" : on parle de qui est la personne, pas de ce qu'elle a fait.
   * C'est la copie la plus importante de l'app.
   */
  insight: {
    welcome: 'Une première séance, même courte, et tout commence.',
    first_session:
      'Première séance enregistrée. C’est le pas le plus difficile, et il est derrière vous.',
    comeback:
      'Vous revenez après {{days}} jours. C’est exactement ce qui distingue ceux qui tiennent.',
    goal_reached:
      'Objectif de la semaine atteint, {{minutes}} minutes. Le reste, c’est du bonus.',
    consecutive_days:
      '{{count}} jours de suite. Vous êtes en train d’installer une habitude.',
    best_streak: '{{count}} semaines d’affilée — votre meilleure série à ce jour.',
    better_than_last_week:
      'Déjà {{minutes}} minutes de plus que la semaine dernière.',
    preferred_moment: 'Vous êtes quelqu’un qui bouge {{moment}}.',
    preferred_day: 'Le {{day}} est votre jour : c’est là que vous bougez le plus.',
    favorite_activity: 'La {{activity}} est ce qui vous fait revenir.',
    steady:
      'Vous avez bougé {{count}} des 4 dernières semaines. C’est ça, la régularité.',
    keep_going: 'Chaque séance compte, même les courtes.',
  },

  moment: {
    morning: 'le matin',
    evening: 'le soir',
  },

  weekday: {
    monday: 'lundi',
    tuesday: 'mardi',
    wednesday: 'mercredi',
    thursday: 'jeudi',
    friday: 'vendredi',
    saturday: 'samedi',
    sunday: 'dimanche',
  },

  quest: {
    move_today: 'Bouger {{count}} min aujourd’hui',
    effort_today: 'Gagner {{count}} min d’effort aujourd’hui',
    activity_today: 'Une séance de {{activity}} aujourd’hui',
    sessions_week: '{{count}} séances cette semaine',
    variety_week: '{{count}} activités différentes',
    active_days: '{{count}} jours d’affilée',
    long_session: 'Une séance de {{count}} min ou plus',
    reach_goal: 'Atteindre l’objectif de la semaine',
    reward: '+{{count}}',
  },

  /** La "fin" : l'app ne se referme jamais sur rien. */
  done: {
    minutesLogged: 'minutes enregistrées',
    title: 'Vous étiez là aujourd’hui',
    body: 'Plus que {{count}} minutes pour l’objectif de la semaine.',
    goalTitle: 'Objectif atteint',
    goalBody: 'Vous avez tenu votre objectif de la semaine. Le reste, c’est du bonus.',
    questsDone: 'Défis réussis',
    back: 'Continuer',
  },

  activity: {
    title: 'Nouvelle séance',
    typeTitle: 'Qu’avez-vous fait ?',
    durationTitle: 'Combien de temps ?',
    whenTitle: 'Quand ?',
    favorites: 'Vos activités',
    others: 'Autres',
    kcal: '~{{count}} kcal',
    empty: 'Aucune séance pour l’instant',
    emptyHint: 'Votre première séance apparaîtra ici.',
  },

  history: {
    title: 'Progrès',
    period: 'Période',
    periodWeek: 'Semaine',
    periodMonth: 'Mois',
    periodQuarter: '3 mois',
    chartTitle: 'Minutes actives',
    weekOf: 'Semaine du {{date}}',
    avgDay: 'Moyenne par jour',
    avgWeek: 'Moyenne par sem.',
    sessions: 'Séances',
    kcal: 'Calories',
    streak: 'Série',
    streakUnit: 'sem.',
    thisWeek: 'Cette semaine',
    journal: 'Journal',
  },

  /**
   * Libellés courts, réservés aux tuiles de sélection : « Renforcement » en
   * capitales déborde d'une tuile de 78 px, quelle que soit la taille de
   * police raisonnable. Les noms complets restent dans les listes et les
   * phrases, où la place ne manque pas.
   */
  activityTypeShort: {
    walk: 'Marche',
    run: 'Course',
    bike: 'Vélo',
    swim: 'Natation',
    strength: 'Muscu',
    yoga: 'Yoga',
    sport: 'Collectif',
    other: 'Autre',
  },

  activityType: {
    walk: 'Marche',
    run: 'Course',
    bike: 'Vélo',
    swim: 'Natation',
    strength: 'Renforcement',
    yoga: 'Yoga',
    sport: 'Sport collectif',
    other: 'Autre',
  },

  intensity: {
    light: 'Intensité légère',
    moderate: 'Intensité modérée',
    vigorous: 'Intensité soutenue',
  },

  primaryGoal: {
    fitness: 'Me remettre en forme',
    habit: 'Créer une habitude durable',
    enjoyment: 'Retrouver du plaisir à bouger',
    endurance: 'Renforcer mon endurance',
    mobility: 'Gagner en souplesse',
    weight: 'Perdre du poids',
    event: 'Préparer un événement',
  },

  profile: {
    title: 'Profil',
    totalSessions: 'séances',
    totalHours: 'au total',
    bestStreak: 'record de série',
    weeklyGoal: 'Objectif hebdomadaire',
    mainGoal: 'Objectif principal',
    favorites: 'Activités préférées',
    body: 'Repères physiques',
    reset: 'Réinitialiser le prototype',
    resetConfirm: 'Effacer toutes les données locales ?',
    loadDemo: 'Charger un historique de démo',
    disclaimer:
      'MovMania est une application de motivation et de bien-être. Elle ne fournit aucun conseil médical, ne propose aucun programme thérapeutique et ne remplace pas l’avis d’un professionnel de santé.',
  },

  nav: {
    home: 'Accueil',
    history: 'Progrès',
    profile: 'Profil',
  },
} as const
